import { SortDirection } from './parcelSearch';

export enum UserManagementSortingOptions {
    email = 'email',
    firstName = 'firstName',
    lastName = 'lastName',
}

export type UserManagementSortOrder = {
    column: UserManagementSortingOptions;
    order: SortDirection;
};

export type UserManagementUser = {
    firstName: string;
    lastName: string;
    email: string;
    username: string;
    id: string;
    enabled: boolean;
    isFederated: boolean;
};
